// noinspection JSUnusedGlobalSymbols
export enum Feature {
  AdminPortalTenantSearch = 'AdminPortalTenantSearch',
  AggressivePolling = 'AggressivePolling',
  AllowTaskActivationWhileInActiveTask = 'AllowTaskActivationWhileInActiveTask',
  AnonymizedTraceDownload = 'AnonymizedTraceDownload',
  AudioRoutingGroups = 'AudioRoutingGroups',
  AudioRoutingGroupsTeamsCalls = 'AudioRoutingGroupsTeamsCalls',
  CallOnBehalf = 'CallOnBehalf',
  CallSupervision = 'CallSupervision',
  CallbackWorkflowActivity = 'CallbackWorkflowActivity',
  ChatHandlerMediaHandling = 'ChatHandlerMediaHandling',
  CleanupReporting = 'CleanupReporting',
  Companion = 'Companion',
  CompanionConversation = 'CompanionConversation',
  CompanionConversationPortal = 'CompanionConversationPortal',
  CompanionCodesSuggestion = 'CompanionCodesSuggestion',
  CompanionDefaultTranscriber = 'CompanionDefaultTranscriber',
  CompanionOutboundTranscription = 'CompanionOutboundTranscription',
  CompanionConversationSplitScreen = 'CompanionConversationSplitScreen',
  CompanionSuggestionsAutoAssign = 'CompanionSuggestionsAutoAssign',
  CompanionTagsSuggestionLanguage = 'CompanionTagsSuggestionLanguage',
  CompanionTagsSuggestion = 'CompanionTagsSuggestion',
  CompanionTranscriptionSummarization = 'CompanionTranscriptionSummarization',
  ConfigurationExport = 'ConfigurationExport',
  CustomWaitingMusic = 'CustomWaitingMusic',
  CustomerJourney = 'CustomerJourney',
  DecommissionInteract = 'DecommissionInteract',
  DecommissionInteractAVToService = 'DecommissionInteractAVToService',
  DecommissionInteractAVToUser = 'DecommissionInteractAVToUser',
  DecommissionInteractChatToService = 'DecommissionInteractChatToService',
  DecommissionInteractChatToUser = 'DecommissionInteractChatToUser',
  DirectCallHandling = 'DirectCallHandling',
  DirectCallReportingBulkEdit = 'DirectCallReportingBulkEdit',
  DirectCallUserFiltering = 'DirectCallUserFiltering',
  EmailRouting = 'EmailRouting',
  EnableDashboardUnifiedEndpoints = 'EnableDashboardUnifiedEndpoints',
  EnableEmergencyManualPresenceMode = 'EnableEmergencyManualPresenceMode',
  EnableNimbusPolicyEngine = 'EnableNimbusPolicyEngine',
  EnableNimbusProvisioningAgent = 'EnableNimbusProvisioningAgent',
  EnableNonBlockingActiveTasks = 'EnableNonBlockingActiveTasks',
  EnableServiceWebChat = 'EnableServiceWebChat',
  EnableSkipDistributionLevels = 'EnableSkipDistributionLevels',
  EnableTransferOnUserExitAVInbound = 'EnableTransferOnUserExitAVInbound',
  EnableUnifyTranscriptionSentimentAnalysis = 'EnableUnifyTranscriptionSentimentAnalysis',
  EnableUserNotReadyReason = 'EnableUserNotReadyReason',
  EnableWallboardAccess = 'EnableWallboardAccess',
  EnableWorkflowImportExport = 'EnableWorkflowImportExport',
  EscalateOnEstablished = 'EscalateOnEstablished',
  ForceTerminateTransferredSessions = 'ForceTerminateTransferredSessions',
  InstantMessaging = 'InstantMessaging',
  Interact = 'Interact',
  InteractForService = 'InteractForService',
  IssueReasons = 'IssueReasons',
  ManageWorkflowTemplates = 'ManageWorkflowTemplates',
  PickupSignal = 'PickupSignal',
  PlanHat = 'PlanHat',
  PreventLicenseBreach = 'PreventLicenseBreach',
  PreventNewTenantOnboarding = 'PreventNewTenantOnboarding',
  RecordingWaveform = 'RecordingWaveform',
  RejectAllCalls = 'RejectAllCalls',
  ShowChangeHistoryOnUi = 'ShowChangeHistoryOnUi',
  ShowLicenseBreachInfo = 'ShowLicenseBreachInfo',
  StoreTaskQueueRedis = 'StoreTaskQueueRedis',
  TaskFlowVisualizer = 'TaskFlowVisualizer',
  UIConfigurationProfiles = 'UIConfigurationProfiles',
  VirtualUser = 'VirtualUser',
  VirtualUserVoiceLiveApiModel = 'VirtualUserVoiceLiveApiModel',
  VirtualUserNimbusAiService = 'VirtualUserNimbusAiService',
  VirtualUserNimbusAiServiceAiWorkflow = 'VirtualUserNimbusAiServiceAiWorkflow',
  VirtualUserTranscription = 'VirtualUserTranscription',
  VirtualUserTranscriptionSummarization = 'VirtualUserTranscriptionSummarization',
  VirtualUserHandover = 'VirtualUserHandover',
  VoicemailContactCenter = 'VoicemailContactCenter',
  VoicemailUnify = 'VoicemailUnify',
  ManagerVoicemails = 'ManagerVoicemails',
  MySessionsContextMenu = 'MySessionsContextMenu',
  NewPresenceService = 'NewPresenceService',
  OriginalCalledTargetNormalization = 'OriginalCalledTargetNormalization',
  WorkflowTemplateChangesPropagation = 'WorkflowTemplateChangesPropagation',
  NimbusUnifyUi = 'NimbusUnifyUi',
}
